<main role="main">
    <section class="jumbotron" style="background-image: url('../../assets/images/laptop-working-header.jpg');">
        <div class="jumbotron_body">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-md-8 col-md-offset-2 text-center">
                        <h1>Matriculación</h1>

                    </div>
                </div>
            </div>
        </div>
        <div class="overlay"></div>
    </section>

    <section class="bg-gray section-sm">
        <div class="">
            <div class="panel-pane pane-atajos">
                <div class="pane-content">
                    <ul class="nav nav-icons nav-icons-selected">
                        <li class="active">
                            <a routerLink="/iniciar-matriculacion">
                                <i class="icono-arg-tramite bg-success"></i><span>Iniciar proceso de
                                    matriculación</span>
                            </a>
                        </li>
                        <li>
                            <a routerLink="/buscar-tramite">
                                <i class="fa fa-search"></i><span>Consultar trámite de matriculación</span>
                            </a>
                        </li>
                    </ul>
                    <div class="row panels-row m-t-2 ">
                        <div class="col-xs-12 col-sm-6 col-md-3 bg-gray">
                            <div class="panel panel-default panel-body bg-gray panel-border-verde-aloe">
                                <div class="media">
                                    <div class="media-left padding-20"><i
                                            class="fa icono-arg-escritura fa-fw fa-2x text-escarapela"></i></div>
                                    <div class="media-body">
                                        <div class="h2 text-success">{{cantidadCertificados}}</div>
                                        <p><b>Certificados Creados</b>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-3 bg-gray">
                            <div class="panel panel-default panel-body bg-gray panel-border-mandarina">
                                <div class="media">
                                    <div class="media-left padding-20"><i
                                            class="fa fa-hourglass-2 fa-fw fa-2x text-escarapela"></i></div>
                                    <div class="media-body">
                                        <div class="h2 text-success">{{cantidadEnProceso}}</div>
                                        <p><b>Procesos en Tramite</b>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-3 bg-gray">
                            <div class="panel panel-default panel-body bg-gray panel-border-verde-aloe">
                                <div class="media">
                                    <div class="media-left padding-20"><i
                                            class="fa icono-arg-validez-legal fa-fw fa-2x text-escarapela"></i></div>
                                    <div class="media-body">
                                        <div class="h2 text-success">{{cantidadFinalizados}}</div>
                                        <p><b>Procesos Finalizados</b>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-3 bg-gray">
                            <div class="panel panel-default panel-body bg-gray" style="border-bottom: 12px solid #fd0707;">
                                <div class="media">
                                    <div class="media-left padding-20"><i
                                            class="fa fa-thumbs-down fa-fw fa-2x text-escarapela"></i></div>
                                    <div class="media-body">
                                        <div class="h2 text-success">{{cantidadErrores}}</div>
                                        <p><b>Procesos con Errores</b>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</main>